<template>

    <div class="overlay fixed" v-show="show">

        <div class="mask-wrapper relative" @click="close">

            <div class="slot absolute" @click.stop>

                <slot></slot>

            </div>

        </div>

    </div>

</template>

<script>
import mixin from "./mixin/mixin";
export default {
    name: "overlay",
    mixins: [mixin],
    props: {
        show: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped src="./style.css"></style>
